import { render, staticRenderFns } from "./DownloadOverview.vue?vue&type=template&id=588ae01e&scoped=true&"
import script from "./DownloadOverview.vue?vue&type=script&lang=js&"
export * from "./DownloadOverview.vue?vue&type=script&lang=js&"
import style0 from "./DownloadOverview.vue?vue&type=style&index=0&id=588ae01e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588ae01e",
  null
  
)

export default component.exports